import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

// Acessos da area do formando (portal da comissao e dos formandos)
export default class AcessosPortalServices {
	listarContratos (filtros = {}) {
		return axios.get(`${REQUEST_URL}/acessos-portal`, {
			params: filtros,
			headers: {"Authorization": localStorage.getItem("token")}
		}).then((response) => response.data);
	}

	detalheDoContrato (contratoId, filtros = {}) {
		return axios.get(`${REQUEST_URL}/acessos-portal/contrato/${contratoId}`, {
			params: filtros,
			headers: {"Authorization": localStorage.getItem("token")}
		}).then((response) => response.data);
	}
}



// WEBPACK FOOTER //
// ./src/services/acessosPortal.js